import React, { useState, useEffect } from 'react';

const InsufficientCreditsModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleInsufficientCredits = () => setIsOpen(true);
        window.addEventListener('insufficient-credits', handleInsufficientCredits);
        return () => window.removeEventListener('insufficient-credits', handleInsufficientCredits);
    }, []);

    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 99999,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)'
        }}>
            <div style={{
                backgroundColor: '#fff', borderRadius: '12px', padding: '24px',
                maxWidth: '400px', width: '100%', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)',
                textAlign: 'center'
            }}>
                <div style={{
                    width: '48px', height: '48px', borderRadius: '50%', backgroundColor: '#fee2e2',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px'
                }}>
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="#ef4444" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#111827', margin: '0 0 8px' }}>Insufficient Credits</h3>
                <p style={{ fontSize: '14px', color: '#4b5563', margin: '0 0 24px', lineHeight: 1.5 }}>
                    You have run out of credits. Please top up or renew your subscription credits to continue executing operations.
                </p>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <button
                        onClick={() => setIsOpen(false)}
                        style={{
                            backgroundColor: '#f3f4f6', color: '#374151', padding: '10px 16px', borderRadius: '8px',
                            border: '1px solid #d1d5db', fontWeight: 500, cursor: 'pointer', flex: 1
                        }}
                    >
                        Dismiss
                    </button>
                    {/* Optional: if there's a billing page, you could add a link here */}
                </div>
            </div>
        </div>
    );
};

export default InsufficientCreditsModal;
